var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,21c-14.888,0-27,12.112-27,27s12.112,27,27,27s27-12.112,27-27S62.888,21,48,21z M48,71c-12.682,0-23-10.317-23-23 c0-12.682,10.318-23,23-23c12.683,0,23,10.318,23,23C71,60.683,60.683,71,48,71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,47.171V30.088c0-1.104-0.896-2-2-2s-2,0.896-2,2v17.909c0,0.01,0,0.02,0,0.029c0,0,0,0,0,0c0,0.002,0,0.003,0,0.004 c0,0,0,0,0,0c0.004,0.259,0.057,0.506,0.151,0.733c0.095,0.229,0.234,0.445,0.417,0.633c0,0.001,0.001,0.001,0.001,0.001 c0-0.002,0.001,0.002,0.003,0.003c0.005,0.005,0.01,0.011,0.015,0.016l7.257,7.257c0.391,0.391,0.902,0.586,1.414,0.586 s1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828L50,47.171z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f2f4e1337d9f524128ce3de145ebba0d.svg";
export { ForwardRef as ReactComponent };